module.exports = __webpack_public_path__ + "fonts/Gilroy-UltraLightItalic.0bf003f5.eot";